/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchOverlapStatus = {
  Active: "active",
  Scheduled: "scheduled",
} as const;
export type KillswitchOverlapStatus = ClosedEnum<
  typeof KillswitchOverlapStatus
>;

/** @internal */
export const KillswitchOverlapStatus$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchOverlapStatus
> = z.enum(KillswitchOverlapStatus);
